<template>
  <div v-if="isShow" class="full-page" style="z-index: 1021">
    <div>
      说明：<br />
      仅展示【姓名公司手机】及【冲突字段】。<br />
      最后一行为合并结果预览。
    </div>
    <div class="full-body">
      <table v-if="isShow" class="a-table" cellspacing="0">
        <tr>
          <th></th>
          <th v-for="(head, key) in heads" :key="key" :class="{ diffitem: isDiff(head) }">{{ head }}</th>
        </tr>
        <tr>
          <td>本条数据</td>
          <template v-for="(head, key) in heads">
            <td
              v-if="isDiff(head)"
              :key="'new' + key"
              title="点击选择"
              :class="{ diffitem: isDiff(head) }"
              @click="pick(head, newData[head])"
            >
              {{ newData[head] }}
            </td>
            <td v-else>{{ newData[head] }}</td>
          </template>
        </tr>
        <tr>
          <td>重复数据</td>
          <template v-for="(head, key) in heads">
            <td
              v-if="isDiff(head)"
              :key="'old' + key"
              title="点击选择"
              :class="{ diffitem: isDiff(head) }"
              @click="pick(head, oldData[head])"
            >
              {{ oldData[head] }}
            </td>
            <td v-else>{{ oldData[head] }}</td>
          </template>
        </tr>
        <tr>
          <td>合并结果预览</td>
          <td v-for="(head, key) in heads" :key="'merge' + key" :class="{ diffitem: isDiff(head) }">
            <span v-if="isDiff(head)" style="color: #ccc">字段冲突,请点击上方选择要保留的数据</span>
            <span v-else>{{ mergedData[head] }}</span>
          </td>
        </tr>
      </table>

      <div style="padding: 10px;">
        <el-button v-show="!sending" type="primary" size="small" @click="confirmMerge">确定合并</el-button>
      </div>
    </div>
    <div class="fix-middle-actions"><el-button circle size="mini" icon="el-icon-close" @click="close"></el-button></div>
  </div>
</template>
<script>
import { isArrEq, mergeLcs } from '../constant/common-methods.js'
import radishFields from '../excel/radish-fields'

export default {
  data() {
    return {
      sending: false,
      isShow: false,
      heads: ['姓名', '手机', '公司'],
      oldId: '',
      newId: '',
      oldData: {},
      newData: {},
      mergedData: {},
      onConfirm: function() {},
    }
  },
  computed: {
    fields() {
      const f = {}
      radishFields.forEach(rf => {
        f[rf] = 1
      })
      return f
    },
  },
  methods: {
    async show(params) {
      const { oldId, newData, onConfirm } = params
      const tmpOld = {}
      const tmpNew = {}
      const tmpMerged = {}
      const res = await app.service('radish').simpleFetch({ _id: oldId, fields: this.fields })
      const oldData = res.data
      for (const field in newData) {
        if (field != '_id' && newData.hasOwnProperty(field)) {
          let mergedVal = newData[field]
          if (newData[field] instanceof Array) {
            if (!oldData[field]) oldData[field] = []
            if (!isArrEq(oldData[field], newData[field])) {
              if (oldData[field].length > 0 && newData[field].length > 0 && !this.heads.includes(field)) {
                this.heads.push(field)
              }
              mergedVal = Array.from(new Set(newData[field].concat(oldData[field])))
            }
          } else if (newData[field] && newData[field] != oldData[field]) {
            if (oldData[field] && !this.heads.includes(field)) {
              this.heads.push(field)
            }
            if (oldData[field]) {
              if (field == '旧系统沟通备注') {
                mergedVal = mergeLcs(oldData[field], newData[field])
              } else {
                mergedVal = ''
              }
            }
          }
          if (this.heads.includes(field)) {
            tmpOld[field] = oldData[field]
            tmpNew[field] = newData[field]
          }
          tmpMerged[field] = mergedVal
        }
      }
      this.oldId = oldData._id
      this.newId = newData._id
      this.oldData = tmpOld
      this.newData = tmpNew
      this.mergedData = tmpMerged
      this.onConfirm = onConfirm || function() {}
      this.isShow = true
    },
    isDiff(head) {
      if (!this.mergedData[head] && this.oldData[head]) return true
      return false
    },
    close() {
      this.isShow = false
    },
    pick(head, val) {
      this.mergedData[head] = val
    },
    async confirmMerge() {
      if (this.sending) return false
      const notHandle = Object.keys(this.mergedData).filter(k => !this.mergedData[k] && this.isDiff(k))
      if (notHandle.length > 0) {
        return this.$message.error('还有未处理的冲突')
      }
      // 合并
      try {
        this.sending = true
        // 修改重复数据
        const res = await app.service('radish').modifyById({ _id: this.oldId, data: this.mergedData })
        if (res.status === 'success') {
          // if (this.newData['姓名'] == this.mergedData['姓名']) {
          // 本条和合并后姓名一样 合并关系并删除本条数据
          await app.service('radish').replaceRelations({ oid: this.newId, nid: this.oldId })
          await app.service('communication').mergeByRadishId({ targetId: this.oldId, ids: [this.newId] })
          await app.service('radish').delete({ _id: this.newId })
          // }
          this.$message.success('合并成功')
          this.onConfirm()
          app.root.$refs.radishDetailTab.addTab({ id: this.oldId })
          this.close()
        } else {
          this.$message.error(res.msg)
        }
        this.sending = false
      } catch (e) {
        console.error(e)
        this.$message.error(e)
        this.sending = false
      }
    },
  },
}
</script>
<style>
.a-table > tr > .diffitem {
  border-left: 1px solid #f00;
  border-right: 1px solid #f00;
  border-bottom: 1px solid #f00;
  cursor: pointer;
}
.a-table > tr > .diffitem:hover {
  background-color: #eee;
}
.a-table > tr > th.diffitem {
  border-top: 1px solid #f00;
}
</style>
